import React from "react";
import { Button } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiHelpCircleOutline } from "@mdi/js";
import "./howItWorksButton.css";

// `show` lets a page render the desktop and mobile halves in two different JSX
// locations — the Jobs list puts the mobile icon beside its title instead of in
// the header actions.
const HowItWorksButton = ({ onClick, show = "both" }) => {
  return (
    <>
      {show !== "mobile" && (
        <Button
          variant="outline-primary"
          className="how-it-works-btn d-none d-md-inline-flex"
          onClick={onClick}
        >
          <Icon path={mdiHelpCircleOutline} size={1} />
          How It Works
        </Button>
      )}

      {show !== "desktop" && (
        <button
          className="how-it-works-icon-btn d-md-none"
          onClick={onClick}
          aria-label="How It Works"
        >
          <Icon path={mdiHelpCircleOutline} size={1} />
        </button>
      )}
    </>
  );
};

export default HowItWorksButton;
